import { alveolarPressure } from "../physics/pressure.js";
import type { GasMix, TissueSnapshot } from "../types.js";
import { N_COMPARTMENTS, ZHL16C, kN2 } from "./constants.js";
import { haldane } from "./haldane.js";

export function schreiner(
  p0: number,
  pInspiredStart: number,
  rate: number,
  k: number,
  t: number,
): number {
  return (
    pInspiredStart +
    rate * (t - 1 / k) -
    (pInspiredStart - p0 - rate / k) * Math.exp(-k * t)
  );
}

export interface DepthSegment {
  startDepth: number;
  endDepth: number;
  duration: number;
  gas: GasMix;
}

export function applySegment(state: TissueSnapshot, seg: DepthSegment): TissueSnapshot {
  if (seg.duration <= 0) return { pN2: [...state.pN2] };

  const pInspiredStart = alveolarPressure(seg.startDepth) * seg.gas.fN2;
  const pInspiredEnd = alveolarPressure(seg.endDepth) * seg.gas.fN2;
  const newPN2 = new Array<number>(N_COMPARTMENTS);

  if (seg.startDepth === seg.endDepth) {
    for (let i = 0; i < N_COMPARTMENTS; i++) {
      const k = kN2(ZHL16C[i]!);
      newPN2[i] = haldane(state.pN2[i]!, pInspiredStart, k, seg.duration);
    }
  } else {
    const rate = (pInspiredEnd - pInspiredStart) / seg.duration;
    for (let i = 0; i < N_COMPARTMENTS; i++) {
      const k = kN2(ZHL16C[i]!);
      newPN2[i] = schreiner(state.pN2[i]!, pInspiredStart, rate, k, seg.duration);
    }
  }

  return { pN2: newPN2 };
}
